import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { Row, Col, message } from "antd";
import { Content } from "antd/es/layout/layout";
// import TotalReferral from '../../Components/DashboardComponents/totalReferral'
import ReferralBanner from "../../Components/DashboardComponents/referralBanner";
import EarningsGraph from "../../Components/DashboardComponents/referralEarningsGraph";
import { useOutletContext } from "react-router-dom";
import TransactionTableReferral from "../../Components/DashboardComponents/transactionTableReferral";
import MyReferralsBanner from "../../Components/DashboardComponents/MyReferralsBanner";
import { useSelector } from "react-redux";

const ROOT = `dashboard_product`;

const DashboardReferrals = (props) => {
  const outletProps = useOutletContext();
  const { colorBgContainer, cardBackgroundColor } = outletProps;
  const { setHeaderTitle, headerTitle} = props;

  useEffect(() => {
    // Update the header title when the component mounts
    setHeaderTitle("My Referrals");
    return () => {
      // Optionally, reset the header title when the component unmounts
      setHeaderTitle("");
    };
  }, [setHeaderTitle]);

  const promotion = useSelector((state) => state.promotion.isCompleted);

  return (
    <Content
      style={{
        minHeight: 280,
        background: colorBgContainer,
        paddingTop: 0,
      }}
      className={`${ROOT}__content_body`}
    >

      <Row gutter={[0, 20]} className="banner_ui">
        <Col lg={24} xs={24} sm={24}>
          <ReferralBanner
          headerTitle={headerTitle}
            cardBackgroundColor={cardBackgroundColor}
            page="my referrals"
          />
        </Col>
      </Row>
      {/* <Col lg={12}>
          <TotalReferral
            cardBackgroundColor={cardBackgroundColor}
            page="my referrals"
          />
        </Col> */}

      <div style={{ background: "#fff" }}>
        <Row className="px-4 my-4 d-flex justify-content-between">
          <Col className="referalls-card-width">
            <EarningsGraph
              cardBackgroundColor={cardBackgroundColor}
              page="my referrals"
            />
          </Col>
          <Col className="referalls-card-width referrals-history-margin">
            <TransactionTableReferral
              cardBackgroundColor={cardBackgroundColor}
              page="my referrals"
            />
          </Col>
        </Row>
      </div>
    </Content>
  );
};

export default DashboardReferrals;
